
<template>
    <div>
        <div class="flex justify-between items-center mb-5">
            <div>
                {{ $t('Adults') }}
            </div>
            <div class="custom-number-input h-10 w-32 mb-4 items-center">
                <div class="flex flex-row h-10 w-full rounded-lg relative bg-transparent mt-1">
                    <button :class="num_adult_temp == 1 ? 'disable' : ''" @click="decrementAdult()"
                        class=" bg-gray-200 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 rounded-l cursor-pointer outline-none">
                        <span class="m-auto text-2xl font-thin">−</span>
                    </button>
                    <input type="number"
                        class="outline-none focus:ring-0 border-none focus:outline-none text-center w-full bg-gray-200 font-semibold text-md hover:text-black focus:text-black  md:text-basecursor-default flex items-center text-gray-700  outline-none"
                        name="custom-guest-number" :value="num_adult_temp" />
                    <button @click="incrementAdult()"
                        class="bg-gray-200 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 rounded-r cursor-pointer">
                        <span class="m-auto text-2xl font-thin">+</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="flex justify-between items-center">
            <div class="flex flex-col leading-5">
                {{ $t('Children') }}
                <small>{{ $t('3 - 17 years old') }}</small>
            </div>
            <div class="custom-number-input h-10 w-32 mb-4 items-center">
                <div class="flex flex-row h-10 w-full rounded-lg relative bg-transparent mt-1">
                    <button :class="num_children_temp == 1 ? 'disable' : ''" @click="decrementChildren()"
                        class=" bg-gray-200 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 rounded-l cursor-pointer outline-none">
                        <span class="m-auto text-2xl font-thin">−</span>
                    </button>
                    <input type="number"
                        class="outline-none focus:ring-0 border-none focus:outline-none text-center w-full bg-gray-200 font-semibold text-md hover:text-black focus:text-black  md:text-basecursor-default flex items-center text-gray-700  outline-none"
                        name="custom-guest-number" :value="num_children_temp" />
                    <button @click="incrementChildren()"
                        class="bg-gray-200 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 rounded-r cursor-pointer">
                        <span class="m-auto text-2xl font-thin">+</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueCookies from 'vue-cookies'

export default {

    props: ['num_adult', 'num_children'],
    data() {
        return {
            num_adult_temp: this.num_adult,
            num_children_temp: this.num_children,
        };
    },
    methods: {
        incrementAdult() {
            this.num_adult_temp++;
            this.$emit("num_adult", this.num_adult_temp);
            this.$emit("guestChanged", [this.num_adult_temp, this.num_children_temp]);
        },
        decrementAdult() {
            if (this.num_adult_temp > 1) {
                this.num_adult_temp--;
                this.$emit("num_adult", this.num_adult_temp);
                this.$emit("guestChanged", [this.num_adult_temp, this.num_children_temp]);
            }
        },
        incrementChildren() {
            this.num_children_temp++;
            this.$emit("num_children", this.num_children_temp);
            this.$emit("guestChanged", [this.num_adult_temp, this.num_children_temp]);
        },
        decrementChildren() {
            if (this.num_children_temp >= 1) {
                this.num_children_temp--;
                this.$emit("num_children", this.num_children_temp);
                this.$emit("guestChanged", [this.num_adult_temp, this.num_children_temp]);
            }
        }
    },
    created() {
        if (VueCookies.get('num_adult')) {
            this.num_adult = parseInt(VueCookies.get('num_adult'))
        }
        if (VueCookies.get('numChild')) {
            this.numChild = parseInt(VueCookies.get('numChild'))
        }
        this.$emit("num_adult", this.num_adult);
        this.$emit("num_children", this.num_children);
    }
}
</script>